null


// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/commands/DescribeEndpointCommand.ts